import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { useValidateLogin } from '../../hooks/auth';
import { LayoutContext } from '../../Providers/LayoutProvider';
import MainLoader from '../Loader/MainLoader';
import { isFeatureLocked } from '../../utils/constants/featureAccess';

/**
 * ROAR-5007 (AC11): route-level counterpart of the sidebar lock. Locking the menu item alone leaves
 * the screen reachable by typing its URL or following a notification link (e.g. a schedule's
 * `?previewScheduleId=` link), so a route behind a locked feature redirects instead of rendering —
 * before the page mounts, so it never fires its own requests. `redirectTo` is relative to the
 * dashboard's `mainUrl` (`/app` or `/admin`), letting one gate serve both route groups.
 *
 * Same rule as the sidebar: only an explicit `locked` redirects; a missing map or key renders the
 * page. Convenience only — the API still rejects calls to a locked feature.
 */
const FeatureRouteGate = ({ featureKey, redirectTo, children }) => {
  const { data, isLoading } = useValidateLogin();
  const { mainUrl } = useContext(LayoutContext);

  if (isLoading) return <MainLoader />;
  if (isFeatureLocked(data?.user?.features, featureKey)) {
    return <Navigate replace to={`${mainUrl}${redirectTo}`} />;
  }
  return children;
};

export default FeatureRouteGate;
